import { memo, MouseEvent } from 'react'

type IProps = {
  bedAreaRef: (element: HTMLOrSVGElement | any) => void
  onMouseMove: (e: MouseEvent) => void
  onPointerEnter: () => void
  onPointerLeave: () => void
  onClick: (e: MouseEvent) => void
}

type IStyle = {
  [key: string]: string | number
}

export const SVGStyle: IStyle = { pointerEvents: 'none' }
export const polygonStyle: IStyle = { pointerEvents: 'auto' }

export const DefaultBed = memo(({ bedAreaRef, onMouseMove, onPointerEnter, onPointerLeave, onClick }: IProps) => {
  return (
    <svg
      viewBox="0 0 718 682"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeMiterlimit: 22.9256
      }}
    >
      <rect
        ref={bedAreaRef}
        onMouseMove={onMouseMove}
        onPointerEnter={onPointerEnter}
        onPointerLeave={onPointerLeave}
        onClick={onClick}
        x="5"
        y="37.5"
        width="709"
        height="596.052"
        color="white"
        style={{ pointerEvents: 'all' }}
      />
      <path
        d="m713.394 634.297.001-596.052-709.049-.001v596.053h709.048Z"
        style={{
          fill: '#434242',
          fillRule: 'nonzero'
        }}
      />
      <path
        d="M717.633 666.784V14.232c0-7.793-6.329-14.123-14.123-14.123H569.007a5.654 5.654 0 0 0-4.839 2.732l-3.923 6.517a4.197 4.197 0 0 1-3.656 2.048H161.155a4.19 4.19 0 0 1-3.654-2.048l-3.927-6.517a5.648 5.648 0 0 0-4.84-2.732H14.235C6.443.109.108 6.437.108 14.232v652.552c0 7.801 6.326 14.123 14.127 14.123H703.51c7.802 0 14.123-6.323 14.123-14.123Z"
        style={{
          fill: '#434242',
          fillRule: 'nonzero',
          stroke: '#2b2a29',
          strokeWidth: '.22px'
        }}
      />
      <path
        d="M15.394 665.509a.56.56 0 0 1-.163-.446l-.006-5.591a.563.563 0 1 1 1.125 0l.006 5.402 1.096 1.096h2.841a.564.564 0 1 1 0 1.13h-3.075l-.029-.001-.012-.001h-.003a.58.58 0 0 1-.181-.045l-.008-.003-.005-.003a.718.718 0 0 1-.061-.033l-.006-.003-.017-.013-.005-.003-.007-.005a.521.521 0 0 1-.075-.066l-.009-.009-1.406-1.406Zm89.15 3.816v-1.508h-3.454l-.73.748.759.76h3.425Zm.048-5.515.97.968c.318.328.477.718.477 1.173v4.115c0 .2-.073.373-.221.522a.716.716 0 0 1-.52.22h-4.487a.76.76 0 0 1-.538-.215l-1.496-1.496a.743.743 0 0 1-.215-.526c0-.207.072-.387.215-.539l1.496-1.495a.78.78 0 0 1 .538-.204h3.733v-.374a.468.468 0 0 0-.038-.138l-.959-.942a.28.28 0 0 0-.132-.064h-2.602a.73.73 0 0 1-.533-.22.7.7 0 0 1-.223-.517.71.71 0 0 1 .223-.527.723.723 0 0 1 .531-.22h2.608c.455 0 .846.159 1.173.479Zm-13.495 2.155v.368h4.487v-.368a.387.387 0 0 0-.047-.135l-.957-.957a.326.326 0 0 0-.132-.058h-2.215a.326.326 0 0 0-.132.058l-.957.957a.387.387 0 0 0-.047.135Zm5.504-1.186c.319.327.478.717.478 1.171v1.114a.732.732 0 0 1-.221.533.717.717 0 0 1-.52.22h-5.241v.361a.36.36 0 0 0 .047.131l.957.957c.04.03.084.049.132.058h4.105c.199 0 .372.074.52.221a.702.702 0 0 1 .221.515.727.727 0 0 1-.221.53.72.72 0 0 1-.52.218h-4.116c-.455 0-.846-.16-1.173-.479l-.969-.969a1.618 1.618 0 0 1-.478-1.172v-2.238c0-.454.159-.844.478-1.171l.969-.969c.327-.319.718-.48 1.173-.48h2.237c.455 0 .846.161 1.172.48l.97.969Zm-9.212-1.448c.2 0 .373.073.521.22a.714.714 0 0 1 .221.528.702.702 0 0 1-.22.516.71.71 0 0 1-.517.219h-1.107a.26.26 0 0 0-.132.081l-2.51 2.498v2.678a.703.703 0 0 1-.222.517.712.712 0 0 1-.52.22.723.723 0 0 1-.531-.221.707.707 0 0 1-.223-.52v-5.982c0-.208.074-.385.223-.533a.723.723 0 0 1 .531-.221c.199 0 .373.074.52.221a.726.726 0 0 1 .222.533v1.184l1.447-1.46a1.622 1.622 0 0 1 1.173-.478h1.124Zm-8.729 5.994v-1.508h-3.454l-.729.748.758.76h3.425Zm.048-5.515.97.968c.318.328.478.718.478 1.173v4.115c0 .2-.074.373-.222.522a.716.716 0 0 1-.52.22h-4.487a.757.757 0 0 1-.538-.215l-1.496-1.496a.743.743 0 0 1-.215-.526c0-.207.072-.387.215-.539l1.496-1.495a.778.778 0 0 1 .538-.204h3.733v-.374a.468.468 0 0 0-.038-.138l-.959-.942a.28.28 0 0 0-.132-.064h-2.602a.73.73 0 0 1-.533-.22.7.7 0 0 1-.223-.517.71.71 0 0 1 .223-.527.722.722 0 0 1 .531-.22h2.609c.454 0 .845.159 1.172.479Zm-17.839 1.005H58.62v3.36a.29.29 0 0 0 .061.132l.943.959a.316.316 0 0 0 .131.058h1.114a.72.72 0 0 1 .52.22.718.718 0 0 1 .222.528.703.703 0 0 1-.222.517.716.716 0 0 1-.52.22h-1.125c-.455 0-.845-.16-1.172-.48l-.968-.968c-.32-.329-.48-.72-.48-1.175v-3.371h-.742a.719.719 0 0 1-.531-.221.696.696 0 0 1-.223-.515c0-.205.074-.382.223-.528a.722.722 0 0 1 .531-.22h.742v-.742c0-.207.074-.385.222-.533a.724.724 0 0 1 .532-.22c.199 0 .372.073.52.22a.727.727 0 0 1 .222.533v.742h2.249c.199 0 .373.073.52.22a.716.716 0 0 1 .222.528.7.7 0 0 1-.222.515.709.709 0 0 1-.52.221Zm-8.158-1.005.97.969c.318.327.477.717.477 1.171v4.116c0 .2-.074.373-.221.521a.727.727 0 0 1-.532.222.712.712 0 0 1-.52-.222.712.712 0 0 1-.222-.521v-4.102a.283.283 0 0 0-.06-.132l-.944-.959a.342.342 0 0 0-.131-.058h-3.352v5.25c0 .2-.07.373-.215.522a.708.708 0 0 1-.526.222.726.726 0 0 1-.532-.222.712.712 0 0 1-.222-.521v-5.982c0-.207.074-.384.222-.532a.725.725 0 0 1 .532-.221h4.103c.455 0 .846.16 1.173.479Zm-9.32-2.722c0 .197-.073.37-.221.516a.713.713 0 0 1-.521.219.722.722 0 0 1-.531-.219.7.7 0 0 1-.222-.516c0-.206.073-.382.222-.528a.723.723 0 0 1 .531-.22c.2 0 .373.073.521.22a.714.714 0 0 1 .221.528Zm.754 8.237c.199 0 .373.074.52.219a.719.719 0 0 1 .222.529c0 .197-.074.37-.222.516a.715.715 0 0 1-.52.219h-2.991a.729.729 0 0 1-.532-.219.703.703 0 0 1-.222-.516c0-.206.074-.382.222-.529a.732.732 0 0 1 .532-.219h.742v-4.511h-.742a.729.729 0 0 1-.532-.219.704.704 0 0 1-.222-.516c0-.206.074-.382.222-.528a.726.726 0 0 1 .532-.22h1.495c.2 0 .373.074.521.222a.726.726 0 0 1 .221.534v5.238h.754Zm-6.281-5.994c.199 0 .373.073.52.22a.715.715 0 0 1 .222.528.703.703 0 0 1-.221.516.708.708 0 0 1-.517.219h-1.107a.253.253 0 0 0-.131.081l-2.511 2.498v2.678a.706.706 0 0 1-.221.517.714.714 0 0 1-.521.22.723.723 0 0 1-.531-.221.706.706 0 0 1-.222-.52v-5.982c0-.208.073-.385.222-.533a.723.723 0 0 1 .531-.221c.2 0 .373.074.521.221a.729.729 0 0 1 .221.533v1.184l1.448-1.46a1.62 1.62 0 0 1 1.172-.478h1.125Zm-8.523.36v-.721a.362.362 0 0 0-.047-.13l-.957-.958a.34.34 0 0 0-.132-.058h-3.351v3.014h3.351a.34.34 0 0 0 .132-.058l.957-.957a.372.372 0 0 0 .047-.132Zm1.017-1.903c.319.327.478.718.478 1.172v.742c0 .455-.159.844-.478 1.173l-.969.967c-.327.321-.718.48-1.173.48h-3.362v3.733a.725.725 0 0 1-.221.532.715.715 0 0 1-.52.222.726.726 0 0 1-.532-.222.722.722 0 0 1-.222-.532v-8.961c0-.207.074-.385.222-.534a.728.728 0 0 1 .532-.22h4.103c.455 0 .846.16 1.173.479l.969.969Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
      />
      <path
        d="M344.313 659.233v-4.238h-2.002v6.651c-1.75.698.391 2.69 1.02 1.176.193-.465-.028-.972-.585-1.176v-6.215h1.085v4.345h3.267c.883 1.08 4.148 4.935 5.379 4.525l1.268-.82-8.828-8.833c-.12 2.052.56 3.011 1.747 4.585h-2.351Zm18.204-2.035c-.051 2.85-1.006 5.424-2.836 7.611l-16.843-16.854c7.966-6.657 19.782-.849 19.679 9.243Zm-4.415 9.157c-10.009 8.06-23.906-3.198-18.224-14.627l1.438-2.221 16.815 16.825-.029.023Zm6.588-9.391c-.268-15.042-20.355-19.309-26.828-6.06-6.165 12.617 8.184 25.721 20.27 18.103 4.144-2.612 6.558-7.141 6.558-12.043Zm-17.399-6.09 9.631 9.636c2.22-2.248 4.021-5.875 1.916-8.525-1.638-2.063-4.893-2.158-6.65.259-1.342-1.34-2.971-2.332-4.897-1.37Z"
        style={{
          fill: '#fefefe'
        }}
      />
      <path
        d="m310.458 655.97-.339-.234.339.234Zm3.104 0-.338-.234.338.234Zm-3.417-13.026c-.624 0-1.203.335-1.516.876l-14.296 24.761c-.671 1.165.172 2.624 1.516 2.624h28.608c1.275-.003 2.275-1.42 1.428-2.746l-14.224-24.639a1.752 1.752 0 0 0-1.516-.876Zm6.44 25.459h-12.871v-1.096h12.871v1.096Zm-2.974-2.184-.704-.424c.018-.032 1.828-3.106.061-4.872-1.788-1.79-.835-4.328-.082-5.42l.676.467c-.078.114-1.761 2.624-.014 4.372 2.224 2.221.152 5.728.063 5.877Zm-3.105 0-.705-.424c.018-.032 1.828-3.106.062-4.872-1.788-1.79-.835-4.328-.081-5.42l.676.467c-.078.114-1.761 2.624-.014 4.372 2.222 2.221.15 5.728.062 5.877Zm-3.154-10.249-.338-.234.339.234h-.001Zm.049 10.249-.705-.424c.017-.032 1.829-3.106.062-4.872-1.79-1.79-.836-4.328-.083-5.42l.677.467c-.078.114-1.761 2.624-.012 4.372 2.221 2.221.149 5.728.061 5.877Zm2.744-21.685 14.462 24.922-.203.159-28.693-.08 14.297-24.921a.162.162 0 0 1 .137-.08ZM267.776 642.945c-.623 0-1.203.336-1.515.876l-14.295 24.76c-.671 1.163.17 2.624 1.516 2.624h28.606c1.19-.003 2.3-1.304 1.429-2.747l-14.224-24.637a1.757 1.757 0 0 0-1.517-.876Zm1.418 23.668c0 1.862-2.827 1.862-2.827 0 0-1.859 2.827-1.859 2.827 0Zm.556-11.52c0-2.745-4.373-2.57-3.891.428l.848 7.674c.079 1.432 2.07 1.43 2.149 0l.894-8.102Zm-1.974-10.557 14.462 24.92-.205.159-28.688-.08 14.431-24.999ZM595.149 668.705a5.02 5.02 0 0 0-.125-1.131 3.007 3.007 0 0 0-.394-.951 2.05 2.05 0 0 0-.683-.654 1.871 1.871 0 0 0-.969-.242c-.383 0-.709.08-.978.242a2.068 2.068 0 0 0-.673.654 2.94 2.94 0 0 0-.394.951c-.084.36-.125.737-.125 1.131 0 .383.041.754.125 1.112.083.36.214.677.394.951.18.276.404.494.673.656.269.161.595.243.978.243.371 0 .695-.082.969-.243.275-.162.502-.38.683-.656.178-.274.31-.591.394-.951a4.91 4.91 0 0 0 .125-1.112Zm105.115.09c-.107.096-.241.17-.403.224a4.27 4.27 0 0 1-.522.134 6.732 6.732 0 0 1-.592.09c-.208.024-.41.054-.601.09a3.965 3.965 0 0 0-.573.144c-.181.06-.339.14-.477.242a1.132 1.132 0 0 0-.332.394 1.264 1.264 0 0 0-.125.583c0 .239.042.435.125.584a.98.98 0 0 0 .341.359c.145.089.312.153.503.189.191.036.39.053.593.053.503 0 .89-.083 1.166-.251a1.68 1.68 0 0 0 .611-.602c.131-.232.212-.469.241-.709.03-.238.045-.43.045-.573v-.951Zm-5.886-1.886c.036-.597.185-1.093.449-1.489a3.043 3.043 0 0 1 1.005-.95c.406-.239.86-.41 1.364-.513a7.801 7.801 0 0 1 1.543-.151c.466 0 .938.033 1.418.099.478.065.915.194 1.309.384.396.193.719.461.97.809.251.347.377.795.377 1.346v4.827c0 .419.023.82.072 1.202.047.383.132.671.251.862h-2.585a3.428 3.428 0 0 1-.116-.44 3.606 3.606 0 0 1-.063-.458 3.396 3.396 0 0 1-1.436.889 5.561 5.561 0 0 1-1.686.26c-.444 0-.857-.056-1.24-.17a2.956 2.956 0 0 1-1.003-.512 2.331 2.331 0 0 1-.674-.861c-.161-.347-.242-.759-.242-1.238 0-.527.089-.96.269-1.301.18-.341.418-.613.718-.817a3.351 3.351 0 0 1 1.013-.458c.377-.101.763-.182 1.159-.243.394-.059.77-.106 1.129-.142.36-.036.679-.09.96-.162.282-.072.506-.176.674-.315.167-.136.251-.338.251-.6 0-.276-.045-.493-.135-.655a.985.985 0 0 0-.358-.377c-.15-.09-.323-.15-.521-.179a4.254 4.254 0 0 0-.637-.045c-.49 0-.883.106-1.176.322-.293.216-.463.574-.511 1.076h-2.548Zm-6.906 3.41c0 .276.057.513.171.709.113.198.26.36.439.485.18.126.386.219.618.279.235.059.477.089.728.089.18 0 .368-.02.566-.063.197-.041.376-.107.538-.196.16-.09.296-.21.404-.36a.947.947 0 0 0 .161-.566.692.692 0 0 0-.197-.492 1.722 1.722 0 0 0-.566-.368 5.637 5.637 0 0 0-.906-.296 32.367 32.367 0 0 0-1.22-.279 13.04 13.04 0 0 1-1.087-.295 3.727 3.727 0 0 1-.941-.45 2.176 2.176 0 0 1-.664-.7c-.168-.28-.251-.625-.251-1.032 0-.586.116-1.073.35-1.462a2.58 2.58 0 0 1 .923-.916 4.08 4.08 0 0 1 1.292-.465c.48-.09.97-.135 1.473-.135.502 0 .99.048 1.462.143.472.096.894.257 1.265.485.37.227.679.529.925.907.245.376.391.851.438 1.426h-2.421c-.036-.491-.222-.823-.557-.996-.335-.173-.73-.26-1.184-.26-.144 0-.3.009-.467.026-.167.019-.32.058-.457.116a.967.967 0 0 0-.35.261c-.096.113-.144.267-.144.457 0 .229.084.413.251.558.168.142.385.259.655.349.27.089.578.17.925.242.345.073.699.151 1.058.234.37.084.733.185 1.086.304a3.6 3.6 0 0 1 .941.476c.276.198.497.442.664.736.168.293.251.655.251 1.085 0 .61-.122 1.122-.366 1.535a2.94 2.94 0 0 1-.962.996 4.038 4.038 0 0 1-1.353.538 7.611 7.611 0 0 1-3.133 0 4.059 4.059 0 0 1-1.373-.547 3.132 3.132 0 0 1-.986-1.013c-.258-.419-.398-.935-.422-1.545h2.423Zm-3.263 3.016h-2.422v-1.292h-.054a3.026 3.026 0 0 1-1.256 1.166 3.554 3.554 0 0 1-1.58.377c-.682 0-1.241-.093-1.677-.278-.437-.186-.781-.443-1.032-.772a2.963 2.963 0 0 1-.53-1.202 7.389 7.389 0 0 1-.152-1.57v-5.707h2.548v5.24c0 .766.123 1.337.368 1.714.244.377.666.565 1.265.565.693 0 1.196-.206 1.507-.619.312-.412.467-1.09.467-2.037v-4.863h2.548v9.278Zm-15.035-9.278h2.423v1.723h.036c.119-.288.28-.553.484-.798a3.17 3.17 0 0 1 .7-.629c.263-.173.547-.308.853-.403.304-.096.612-.144.924-.144.191 0 .376.029.556.09v2.369a4.8 4.8 0 0 0-.916-.09c-.466 0-.861.078-1.183.232a2.078 2.078 0 0 0-.782.638 2.545 2.545 0 0 0-.42.95 5.157 5.157 0 0 0-.126 1.158v4.182h-2.549v-9.278Zm-7.978 2.495h2.188c.324 0 .635-.024.934-.072.299-.048.562-.141.79-.279.226-.137.41-.332.547-.584.137-.25.206-.58.206-.987 0-.405-.069-.734-.206-.986a1.524 1.524 0 0 0-.547-.583 2.173 2.173 0 0 0-.79-.278 5.882 5.882 0 0 0-.934-.073h-2.188v3.842Zm-2.818-6.03h5.779c.801 0 1.483.115 2.045.35.563.233 1.021.541 1.372.923.354.384.612.824.773 1.32.162.496.242 1.002.242 1.515 0 .528-.08 1.035-.242 1.527-.161.49-.419.927-.773 1.31-.351.383-.809.69-1.372.924-.562.233-1.244.349-2.045.349h-2.961v4.595h-2.818v-12.813Zm-9.063 5.24h-1.525v-1.705h1.525v-.719c0-.406.062-.783.188-1.129.125-.347.321-.646.583-.897.263-.252.586-.446.97-.584.383-.138.837-.206 1.363-.206.228 0 .455.009.683.027.226.018.449.032.664.043v1.922a8.126 8.126 0 0 0-.934-.055c-.346 0-.594.081-.745.24-.148.161-.223.429-.223.808v.55h1.757v1.705h-1.757v7.573h-2.549v-7.573Zm-3.843 1.938c-.12-.645-.333-1.137-.639-1.472-.304-.335-.767-.501-1.389-.501-.407 0-.745.068-1.015.206a1.875 1.875 0 0 0-.987 1.157c-.065.227-.104.43-.116.61h4.146Zm-4.146 1.615c.036.814.245 1.408.628 1.785.382.377.932.567 1.651.567.514 0 .957-.129 1.328-.386.37-.259.598-.53.682-.818h2.243c-.36 1.102-.91 1.897-1.652 2.387-.741.491-1.638.736-2.691.736-.729 0-1.387-.12-1.974-.359a4.183 4.183 0 0 1-1.49-1.005 4.466 4.466 0 0 1-.941-1.543 5.61 5.61 0 0 1-.332-1.974c0-.695.112-1.341.341-1.938.226-.598.55-1.116.969-1.552a4.531 4.531 0 0 1 1.498-1.032 4.804 4.804 0 0 1 1.929-.377c.79 0 1.478.152 2.063.458a4.127 4.127 0 0 1 1.446 1.228c.377.516.648 1.102.816 1.76.168.657.228 1.345.18 2.063h-6.694Zm-9.052 1.004c0 .276.057.513.17.709.114.198.261.36.44.485.18.126.386.219.619.279.233.059.476.089.727.089.181 0 .368-.02.566-.063.198-.041.376-.107.538-.196.161-.09.296-.21.403-.36a.94.94 0 0 0 .162-.566.684.684 0 0 0-.198-.492 1.696 1.696 0 0 0-.565-.368 5.637 5.637 0 0 0-.906-.296 31.49 31.49 0 0 0-1.22-.279 12.913 12.913 0 0 1-1.086-.295 3.734 3.734 0 0 1-.942-.45 2.166 2.166 0 0 1-.664-.7c-.168-.28-.252-.625-.252-1.032 0-.586.117-1.073.351-1.462.233-.388.541-.693.924-.916.383-.22.813-.376 1.292-.465.478-.09.969-.135 1.471-.135a7.4 7.4 0 0 1 1.463.143c.473.096.894.257 1.265.485.371.227.679.529.924.907.246.376.392.851.44 1.426h-2.423c-.036-.491-.221-.823-.556-.996-.335-.173-.73-.26-1.184-.26-.144 0-.3.009-.467.026-.167.019-.32.058-.457.116a.967.967 0 0 0-.35.261c-.096.113-.144.267-.144.457 0 .229.084.413.251.558.168.142.386.259.655.349.27.089.577.17.924.242.347.073.7.151 1.059.234.371.084.733.185 1.086.304.353.121.667.279.942.476.275.198.497.442.664.736.167.293.251.655.251 1.085 0 .61-.122 1.122-.368 1.535a2.926 2.926 0 0 1-.96.996 4.06 4.06 0 0 1-1.354.538 7.39 7.39 0 0 1-1.553.162 7.595 7.595 0 0 1-1.579-.162 4.042 4.042 0 0 1-1.373-.547 3.125 3.125 0 0 1-.987-1.013c-.257-.419-.398-.935-.422-1.545h2.423Zm-9.847-1.614c0 .371.036.732.107 1.086.073.352.196.67.369.951.173.28.404.506.691.673.287.168.645.252 1.077.252.431 0 .791-.084 1.086-.252.293-.167.525-.393.698-.673a2.87 2.87 0 0 0 .368-.951 5.563 5.563 0 0 0 0-2.181 2.78 2.78 0 0 0-.368-.951 2.029 2.029 0 0 0-.698-.673c-.295-.173-.655-.259-1.086-.259-.432 0-.79.086-1.077.259a2.06 2.06 0 0 0-.691.673 2.843 2.843 0 0 0-.369.951c-.071.36-.107.724-.107 1.095Zm-2.549 0c0-.741.115-1.414.341-2.019a4.355 4.355 0 0 1 .97-1.543 4.341 4.341 0 0 1 1.508-.987c.585-.234 1.244-.35 1.974-.35.729 0 1.391.116 1.982.35a4.315 4.315 0 0 1 1.517.987c.419.425.742.939.968 1.543.228.605.341 1.278.341 2.019 0 .742-.113 1.412-.341 2.01a4.343 4.343 0 0 1-.968 1.535 4.356 4.356 0 0 1-1.517.987c-.591.232-1.253.35-1.982.35-.73 0-1.389-.118-1.974-.35a4.384 4.384 0 0 1-1.508-.987 4.375 4.375 0 0 1-.97-1.535c-.226-.598-.341-1.268-.341-2.01Zm-1.083.592c0 .276-.018.575-.054.896a5.082 5.082 0 0 1-.206.971 3.725 3.725 0 0 1-.44.924 3.057 3.057 0 0 1-.763.789 3.738 3.738 0 0 1-1.166.556c-.461.137-1.008.206-1.642.206a5.495 5.495 0 0 1-1.561-.223 3.83 3.83 0 0 1-1.346-.709 3.553 3.553 0 0 1-.951-1.229c-.241-.497-.359-1.098-.359-1.804v-1.113h2.548v.574c0 .312.024.599.072.862.048.264.131.487.251.673.12.186.284.332.493.439.21.108.482.161.817.161.371 0 .658-.065.861-.196.204-.133.352-.302.44-.512.09-.209.144-.436.162-.681.018-.246.027-.482.027-.71v-8.649h2.817v8.775Zm-15.882 5.204c-.275.742-.658 1.277-1.147 1.607-.492.329-1.174.493-2.047.493-.264 0-.523-.009-.78-.027a31.585 31.585 0 0 1-.782-.063v-2.099l.736.072c.252.023.504.029.755.017.215-.023.397-.093.546-.206.15-.114.26-.254.332-.422.073-.167.108-.348.108-.538 0-.204-.035-.395-.108-.574l-3.266-8.704h2.728l2.1 6.353h.036l2.027-6.353h2.639l-3.877 10.444Zm-14.564-13.979h2.547v4.666h.037c.31-.479.732-.829 1.264-1.05a4.274 4.274 0 0 1 1.66-.332 3.537 3.537 0 0 1 2.612 1.167c.364.393.661.899.888 1.515.227.617.342 1.35.342 2.198 0 .851-.115 1.582-.342 2.2-.227.616-.524 1.123-.888 1.525a3.465 3.465 0 0 1-1.23.887 3.504 3.504 0 0 1-1.382.289c-.681 0-1.292-.112-1.83-.333a2.352 2.352 0 0 1-1.219-1.104h-.038v1.186h-2.421v-12.814ZM500.01 647.647c0 .747.087 1.474.263 2.181.173.706.451 1.341.834 1.906.382.565.88 1.018 1.496 1.358.614.341 1.361.512 2.243.512.88 0 1.628-.171 2.243-.512a4.288 4.288 0 0 0 1.496-1.358c.381-.565.661-1.2.835-1.906a9.143 9.143 0 0 0 .261-2.181 9.81 9.81 0 0 0-.261-2.268 6.01 6.01 0 0 0-.835-1.958 4.267 4.267 0 0 0-1.496-1.371c-.615-.339-1.363-.51-2.243-.51-.882 0-1.629.171-2.243.51a4.24 4.24 0 0 0-1.496 1.371 5.945 5.945 0 0 0-.834 1.958 9.65 9.65 0 0 0-.263 2.268Zm190.411 1.943h4.611l-2.244-6.53h-.05l-2.317 6.53Zm.373-10.916h4.012l6.655 17.795h-4.062l-1.346-3.962h-6.655l-1.396 3.962h-3.962l6.754-17.795Zm-17.684 11.889c0 .598.108 1.104.324 1.519.216.416.503.753.86 1.01.358.258.772.449 1.247.573a5.87 5.87 0 0 0 1.507.188 7.69 7.69 0 0 0 1.122-.088c.399-.058.772-.17 1.122-.336.349-.166.639-.395.872-.685.232-.291.349-.662.349-1.11 0-.481-.154-.872-.462-1.172-.308-.298-.709-.551-1.208-.759a10.156 10.156 0 0 0-1.695-.524 34.378 34.378 0 0 1-1.919-.486 17.144 17.144 0 0 1-1.944-.61 6.67 6.67 0 0 1-1.695-.935 4.422 4.422 0 0 1-1.209-1.422c-.308-.564-.461-1.261-.461-2.093 0-.913.194-1.708.586-2.38.389-.673.9-1.234 1.533-1.682a6.61 6.61 0 0 1 2.143-.997 9.122 9.122 0 0 1 2.393-.325c.93 0 1.823.104 2.679.312a6.697 6.697 0 0 1 2.281 1.01 5.084 5.084 0 0 1 1.582 1.782c.391.722.587 1.598.587 2.628h-3.789c-.034-.531-.146-.97-.337-1.32a2.193 2.193 0 0 0-.76-.822 3.208 3.208 0 0 0-1.097-.424 6.725 6.725 0 0 0-1.321-.125 4.61 4.61 0 0 0-.947.1 2.54 2.54 0 0 0-.86.348 2.128 2.128 0 0 0-.635.636c-.167.259-.249.57-.249.936 0 .349.065.631.199.847.132.216.394.411.785.585.39.175.931.358 1.62.549.689.191 1.591.428 2.705.71.216.05.498.121.846.213.35.09.719.215 1.111.374.389.157.78.36 1.171.61.39.249.748.557 1.072.922a4.4 4.4 0 0 1 .785 1.308c.199.508.299 1.093.299 1.758 0 .813-.159 1.57-.474 2.267a4.908 4.908 0 0 1-1.409 1.807c-.623.508-1.396.907-2.317 1.197-.923.291-1.99.436-3.203.436-.981 0-1.932-.124-2.855-.373-.921-.25-1.731-.631-2.429-1.147a5.776 5.776 0 0 1-1.683-1.969c-.423-.798-.627-1.745-.61-2.841h3.788Zm-5.396-.823c0 2.41-.672 4.204-2.018 5.384-1.347 1.18-3.208 1.769-5.584 1.769-2.409 0-4.275-.585-5.595-1.757-1.322-1.172-1.983-2.969-1.983-5.396v-11.067h3.914v11.067c0 .481.041.956.125 1.42.083.466.257.882.523 1.247.266.366.636.657 1.109.872.474.217 1.11.324 1.907.324 1.395 0 2.359-.311 2.891-.934s.798-1.599.798-2.929v-11.067h3.913v11.067Zm-28.359-3.017h4.288c.88 0 1.548-.198 2.005-.597.457-.399.686-1.046.686-1.945 0-.863-.229-1.49-.686-1.881-.457-.39-1.125-.585-2.005-.585h-4.288v5.008Zm-3.914-8.049h9.596c.798 0 1.517.128 2.157.386a4.974 4.974 0 0 1 1.645 1.058c.457.449.805.973 1.047 1.571.241.599.362 1.23.362 1.895 0 1.046-.222 1.952-.661 2.716-.441.765-1.159 1.347-2.156 1.745v.049c.482.134.88.338 1.196.612.316.274.573.602.772.985.2.381.345.792.437 1.233.091.44.153.885.186 1.334.017.282.033.614.05.997.017.382.046.768.088 1.158.041.391.108.769.199 1.135.091.365.229.672.411.921h-3.913a4.265 4.265 0 0 1-.261-.934 17.433 17.433 0 0 1-.15-1.072 23.957 23.957 0 0 1-.1-1.146 13.88 13.88 0 0 0-.112-1.11c-.133-.93-.416-1.611-.847-2.044-.432-.431-1.139-.647-2.118-.647h-3.914v6.953h-3.914v-17.795Zm-11.707 8.374h3.041c.449 0 .881-.033 1.296-.1a3.008 3.008 0 0 0 1.097-.386c.316-.191.57-.461.76-.81.19-.348.287-.806.287-1.371s-.097-1.022-.287-1.371a2.1 2.1 0 0 0-.76-.81 3.028 3.028 0 0 0-1.097-.387 8.365 8.365 0 0 0-1.296-.099h-3.041v5.334Zm-3.913-8.374h8.026c1.113 0 2.06.161 2.842.486.78.323 1.416.751 1.907 1.283a4.937 4.937 0 0 1 1.071 1.832c.225.689.337 1.391.337 2.106 0 .731-.112 1.438-.337 2.118a4.953 4.953 0 0 1-1.071 1.82c-.491.532-1.127.959-1.907 1.284-.782.324-1.729.486-2.842.486h-4.113v6.38h-3.913v-17.795Zm-20.463 0h3.913v14.506h8.674v3.29h-12.587v-17.796Zm-12.054 10.916h4.611l-2.243-6.53h-.05l-2.318 6.53Zm.374-10.916h4.013l6.655 17.795h-4.063l-1.346-3.962h-6.654l-1.396 3.962h-3.962l6.753-17.795Zm-22.796 0h3.888l7.428 11.939h.049v-11.939h3.664v17.796h-3.913l-7.402-11.915h-.05v11.915h-3.664v-17.796Zm-6.78 0h3.913v17.796h-3.913v-17.796Zm-5.548 15.776c-.698.898-1.47 1.53-2.318 1.894a6.42 6.42 0 0 1-2.566.549c-1.38 0-2.61-.24-3.69-.722-1.08-.483-1.994-1.138-2.742-1.97-.747-.83-1.321-1.811-1.72-2.94a10.806 10.806 0 0 1-.597-3.614c0-1.313.199-2.543.597-3.689.399-1.148.973-2.145 1.72-2.991a7.865 7.865 0 0 1 2.742-1.994c1.08-.483 2.31-.724 3.69-.724.913 0 1.798.138 2.654.412a7.345 7.345 0 0 1 2.305 1.208 6.893 6.893 0 0 1 1.708 1.97c.456.781.735 1.678.834 2.692h-3.738c-.233-.997-.685-1.745-1.358-2.243-.673-.499-1.476-.748-2.405-.748-.881 0-1.629.171-2.243.51a4.23 4.23 0 0 0-1.496 1.37 6.004 6.004 0 0 0-.835 1.958 9.716 9.716 0 0 0-.262 2.269c0 .748.087 1.473.262 2.18a5.87 5.87 0 0 0 .835 1.907c.381.565.88 1.018 1.496 1.359.614.339 1.362.51 2.243.51 1.279 0 2.276-.328 2.991-.984.713-.656 1.129-1.607 1.246-2.854h-3.939v-2.917h7.478v9.621h-2.493l-.399-2.019Zm-19.611-15.776h3.914v17.796h-3.914v-17.796Zm-13.419 8.049h4.288c.88 0 1.548-.198 2.005-.597.458-.399.686-1.046.686-1.945 0-.863-.228-1.49-.686-1.881-.457-.39-1.125-.585-2.005-.585h-4.288v5.008Zm-3.913-8.049h9.596c.798 0 1.516.128 2.156.386a4.974 4.974 0 0 1 1.645 1.058c.457.449.806.973 1.047 1.571.241.599.362 1.23.362 1.895 0 1.046-.221 1.952-.661 2.716-.441.765-1.159 1.347-2.155 1.745v.049c.481.134.879.338 1.196.612.315.274.572.602.772.985.199.381.344.792.436 1.233.091.44.154.885.187 1.334.017.282.033.614.05.997.017.382.045.768.087 1.158.041.391.108.769.2 1.135a2.6 2.6 0 0 0 .411.921h-3.914a4.379 4.379 0 0 1-.261-.934 17.433 17.433 0 0 1-.15-1.072 25.342 25.342 0 0 1-.099-1.146c-.025-.39-.063-.76-.113-1.11-.132-.93-.415-1.611-.846-2.044-.433-.431-1.14-.647-2.119-.647h-3.914v6.953h-3.913v-17.795Zm-19.514 8.973c0-1.312.198-2.544.598-3.689.399-1.148.972-2.145 1.719-2.992a7.875 7.875 0 0 1 2.742-1.993c1.081-.483 2.31-.724 3.69-.724 1.379 0 2.608.241 3.689.724a7.871 7.871 0 0 1 2.741 1.993c.748.847 1.322 1.844 1.719 2.992.4 1.145.599 2.377.599 3.689 0 1.279-.199 2.483-.599 3.614a8.61 8.61 0 0 1-1.719 2.94c-.747.831-1.662 1.487-2.741 1.97-1.081.482-2.31.722-3.689.722-1.38 0-2.609-.24-3.69-.722a8.065 8.065 0 0 1-2.742-1.97c-.747-.831-1.32-1.811-1.719-2.94a10.756 10.756 0 0 1-.598-3.614ZM3.866 37.764h710.008v597.013H3.866V37.764ZM712.913 67.54H572.064v140.849h140.849V67.54Zm-141.809 0h-140.85v140.849h140.85V67.54Zm-141.809 0h-140.85v140.849h140.85V67.54Zm-141.81 0h-140.85v140.849h140.85V67.54Zm-141.809 0H4.826v140.849h140.85V67.54Zm567.237 141.809H572.064v140.85h140.849v-140.85Zm-141.809 0h-140.85v140.85h140.85v-140.85Zm-141.809 0h-140.85v140.85h140.85v-140.85Zm-141.81 0h-140.85v140.85h140.85v-140.85Zm-141.809 0H4.826v140.85h140.85v-140.85Zm567.237 141.809H572.064v140.85h140.849v-140.85Zm-141.809 0h-140.85v140.85h140.85v-140.85Zm-141.809 0h-140.85v140.85h140.85v-140.85Zm-141.81 0h-140.85v140.85h140.85v-140.85Zm-141.809 0H4.826v140.85h140.85v-140.85Zm567.237 141.81H572.064v140.85h140.849v-140.85Zm-141.809 0h-140.85v140.85h140.85v-140.85Zm-141.809 0h-140.85v140.85h140.85v-140.85Zm-141.81 0h-140.85v140.85h140.85v-140.85Zm-141.809 0H4.826v140.85h140.85v-140.85ZM712.913 66.126V38.724H572.064v27.402h140.849Zm-141.809 0V38.724h-140.85v27.402h140.85Zm-141.809 0V38.724h-140.85v27.402h140.85Zm-141.81 0V38.724h-140.85v27.402h140.85Zm-141.809 0V38.724H4.826v27.402h140.85Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(28.378)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(56.756)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(85.134)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(113.512)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(141.89)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(170.268)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(198.646)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(227.025)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(255.403)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(283.781)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(312.159)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(340.537)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(368.915)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(397.293)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(425.671)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(454.049)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(482.427)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(510.805)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(539.183)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(567.561)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(595.939)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(624.318)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(652.696)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(681.074)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.25px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="translate(709.452)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 33.734)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 62.154)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 90.574)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 118.994)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 147.414)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 175.833)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 204.253)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 232.673)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 261.093)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 289.513)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 317.933)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 346.353)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 374.772)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 403.192)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 431.612)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 460.032)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 488.452)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 516.872)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 545.292)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 573.711)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 602.131)"
      />
      <path
        d="M4.226 37.764v597.013"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.23px',
          strokeLinejoin: 'round',
          strokeMiterlimit: 1.5
        }}
        transform="matrix(0 1 -1.18866 0 758.763 630.551)"
      />
      <path
        d="M275.046 20.221c.456 0 .847.16 1.176.48l1.236 1.236a.759.759 0 0 1 .216.54c0 .2-.074.374-.222.522a.715.715 0 0 1-.523.222.759.759 0 0 1-.54-.216l-1.224-1.224a.28.28 0 0 0-.131-.06h-2.22a.287.287 0 0 0-.133.06l-.959.948a.375.375 0 0 0-.049.132v.72a.375.375 0 0 0 .049.132l.959.948c.04.032.085.052.133.06h2.232c.456 0 .847.16 1.176.48l.972.972c.319.328.48.72.48 1.176v.744c0 .456-.161.848-.48 1.176l-.972.972c-.329.32-.72.48-1.176.48h-2.244c-.456 0-.849-.16-1.176-.48l-1.236-1.236a.759.759 0 0 1-.216-.54c0-.2.074-.374.222-.522a.728.728 0 0 1 .534-.222c.199 0 .375.072.527.216l1.224 1.224c.04.032.085.052.133.06h2.22a.28.28 0 0 0 .131-.06l.961-.948a.372.372 0 0 0 .047-.132v-.72a.372.372 0 0 0-.047-.132l-.961-.948a.28.28 0 0 0-.131-.06h-2.232c-.456 0-.849-.16-1.176-.48l-.972-.972a1.621 1.621 0 0 1-.48-1.176v-.744c0-.456.159-.848.48-1.176l.972-.972c.327-.32.72-.48 1.176-.48h2.244ZM286.213 20.221a.71.71 0 0 1 .529.222.738.738 0 0 1 .216.534v9c0 .2-.072.374-.216.522a.71.71 0 0 1-.529.222.718.718 0 0 1-.532-.223.71.71 0 0 1-.224-.523v-3.766h-4.5v3.766c0 .2-.07.375-.216.523a.703.703 0 0 1-.528.223.727.727 0 0 1-.533-.222.715.715 0 0 1-.223-.522v-9c0-.208.075-.386.223-.534a.727.727 0 0 1 .533-.222c.208 0 .386.074.528.222a.73.73 0 0 1 .216.534v3.744h4.5v-3.744c0-.208.074-.386.224-.534a.72.72 0 0 1 .532-.222ZM295.738 21.71h-5.256v3.011h3.756c.2 0 .374.074.522.22a.71.71 0 0 1 .222.519.717.717 0 0 1-.222.529.717.717 0 0 1-.522.221h-3.756v3.022h5.256c.2 0 .374.076.522.222a.702.702 0 0 1 .222.517.723.723 0 0 1-.222.531.72.72 0 0 1-.522.22h-6a.724.724 0 0 1-.533-.222.725.725 0 0 1-.223-.534v-8.989c0-.207.074-.385.223-.534a.724.724 0 0 1 .533-.222h6c.2 0 .374.074.522.22a.722.722 0 0 1 .222.53.704.704 0 0 1-.222.518.713.713 0 0 1-.522.221ZM304.858 21.71h-5.256v3.011h3.756c.2 0 .374.074.522.22a.71.71 0 0 1 .222.519.717.717 0 0 1-.222.529.717.717 0 0 1-.522.221h-3.756v3.022h5.256c.2 0 .374.076.522.222a.702.702 0 0 1 .222.517.723.723 0 0 1-.222.531.72.72 0 0 1-.522.22h-6a.724.724 0 0 1-.533-.222.725.725 0 0 1-.223-.534v-8.989c0-.207.074-.385.223-.534a.724.724 0 0 1 .533-.222h6c.2 0 .374.074.522.22a.722.722 0 0 1 .222.53.704.704 0 0 1-.222.518.713.713 0 0 1-.522.221ZM313.978 20.221c.2 0 .374.073.522.221a.717.717 0 0 1 .222.529.707.707 0 0 1-.222.518.716.716 0 0 1-.522.22h-2.256v8.255a.726.726 0 0 1-.222.534.712.712 0 0 1-.522.223.721.721 0 0 1-.533-.223.724.724 0 0 1-.223-.534v-8.255h-2.244a.726.726 0 0 1-.533-.22.704.704 0 0 1-.223-.518c0-.206.074-.383.223-.529a.723.723 0 0 1 .533-.221h6ZM331.463 28.082v-2.229a.467.467 0 0 0-.038-.133l-.963-.946a.29.29 0 0 0-.132-.064h-3.367v4.523h3.36a.326.326 0 0 0 .132-.058l.96-.96a.391.391 0 0 0 .048-.133Zm.047-4.38.973.972c.319.328.479.72.479 1.176v2.244c0 .456-.16.847-.479 1.175l-.973.972c-.328.32-.72.481-1.176.481h-4.116a.724.724 0 0 1-.532-.222.709.709 0 0 1-.224-.522v-9c0-.208.074-.386.224-.535a.723.723 0 0 1 .532-.221c.2 0 .374.074.522.221a.729.729 0 0 1 .223.535v2.244h3.371c.456 0 .848.16 1.176.48ZM341.327 23.221c.208 0 .386.074.534.222a.728.728 0 0 1 .222.534v5.616c0 .456-.16.848-.48 1.176l-.972.972c-.328.32-.72.48-1.176.48h-2.628a.712.712 0 0 1-.521-.22.704.704 0 0 1-.223-.518c0-.206.074-.383.223-.53a.712.712 0 0 1 .521-.22h2.617a.342.342 0 0 0 .132-.059l.96-.96a.392.392 0 0 0 .047-.132v-.361h-3.372c-.456 0-.848-.16-1.176-.48l-.972-.972c-.32-.328-.48-.72-.48-1.176v-2.616c0-.208.074-.386.223-.534a.71.71 0 0 1 .521-.222c.208 0 .386.074.534.223a.725.725 0 0 1 .222.534v2.604a.372.372 0 0 0 .047.132l.96.96c.04.029.084.049.132.059h3.361v-3.754c0-.208.074-.387.223-.535a.708.708 0 0 1 .521-.223ZM358.822 23.582v-.722a.372.372 0 0 0-.047-.132l-.96-.959a.328.328 0 0 0-.132-.059h-3.361v3.022h3.361a.324.324 0 0 0 .132-.057l.96-.96a.37.37 0 0 0 .047-.133Zm1.021-1.908c.319.328.479.72.479 1.175v.745c0 .456-.16.847-.479 1.176l-.973.97c-.328.322-.72.482-1.176.482h-3.372v3.744a.728.728 0 0 1-.222.534.722.722 0 0 1-.522.222.732.732 0 0 1-.533-.222.725.725 0 0 1-.223-.534v-8.989c0-.207.074-.385.223-.534a.724.724 0 0 1 .533-.222h4.116c.456 0 .848.161 1.176.481l.973.972ZM367.191 23.221c.2 0 .374.073.522.221a.717.717 0 0 1 .222.529.706.706 0 0 1-.221.518.71.71 0 0 1-.519.22h-1.11a.26.26 0 0 0-.132.081l-2.518 2.505v2.686a.708.708 0 0 1-.222.519.713.713 0 0 1-.522.221.724.724 0 0 1-.533-.222.712.712 0 0 1-.223-.522v-6c0-.208.074-.386.223-.534a.724.724 0 0 1 .533-.222c.2 0 .374.074.522.222a.728.728 0 0 1 .222.534v1.188l1.452-1.464c.328-.32.72-.48 1.176-.48h1.128ZM376.311 23.221c.2 0 .374.074.522.222a.728.728 0 0 1 .222.534v6c0 .2-.074.374-.222.522a.714.714 0 0 1-.522.222h-4.128c-.456 0-.848-.16-1.176-.48l-.971-.972a1.622 1.622 0 0 1-.481-1.176v-4.116c0-.208.074-.386.223-.534a.724.724 0 0 1 .533-.222c.2 0 .374.074.522.222a.728.728 0 0 1 .222.534v4.102a.276.276 0 0 0 .062.133l.945.962c.04.029.084.049.132.059h3.361v-5.254c0-.209.074-.387.223-.535a.721.721 0 0 1 .533-.223ZM384.723 26.702l1.236 1.235a.756.756 0 0 1 .216.54.743.743 0 0 1-.216.529l-1.236 1.235c-.328.32-.72.481-1.176.481h-4.116a.73.73 0 0 1-.533-.22.708.708 0 0 1-.223-.519c0-.206.074-.383.223-.529a.73.73 0 0 1 .534-.221h4.104a.34.34 0 0 0 .132-.058l.696-.695-.696-.712a.37.37 0 0 0-.132-.046h-2.232c-.456 0-.849-.161-1.177-.481l-1.236-1.235a.76.76 0 0 1-.216-.54c0-.201.072-.376.216-.529l1.236-1.235c.328-.32.72-.48 1.176-.48h4.128c.2 0 .374.073.522.22a.72.72 0 0 1 .222.53.7.7 0 0 1-.223.517.712.712 0 0 1-.522.221h-4.124a.352.352 0 0 0-.133.05l-.694.712.703.703a.34.34 0 0 0 .132.058h2.233c.456 0 .848.157 1.176.469ZM393.795 29.233v-1.512h-3.464l-.732.75.761.762h3.435Zm.048-5.531.973.971c.319.329.479.72.479 1.176v4.128c0 .2-.074.374-.222.523a.717.717 0 0 1-.522.221h-4.5a.759.759 0 0 1-.54-.216l-1.5-1.5a.745.745 0 0 1-.216-.528c0-.208.072-.388.216-.54l1.5-1.5a.783.783 0 0 1 .54-.204h3.744v-.376a.468.468 0 0 0-.038-.138l-.962-.945a.28.28 0 0 0-.133-.064h-2.609a.732.732 0 0 1-.535-.221.703.703 0 0 1-.223-.518c0-.206.074-.383.223-.529a.727.727 0 0 1 .533-.221h2.616c.456 0 .848.16 1.176.481ZM404.414 23.593c0 .456-.16.848-.478 1.176l-.709.708.709.696c.318.328.478.72.478 1.176v.744c0 .456-.16.848-.478 1.176l-.974.971c-.328.321-.72.481-1.176.481h-2.244c-.456 0-.848-.16-1.176-.481l-1.236-1.235a.759.759 0 0 1-.216-.54c0-.2.074-.374.221-.522a.721.721 0 0 1 .531-.222c.199 0 .374.074.525.224l1.224 1.223c.04.034.084.056.133.065h2.224a.265.265 0 0 0 .133-.074l.962-.945a.353.353 0 0 0 .047-.132v-.721a.352.352 0 0 0-.047-.133l-.962-.947a.283.283 0 0 0-.132-.06h-2.603a.73.73 0 0 1-.534-.22.707.707 0 0 1-.222-.518c0-.206.074-.383.223-.53a.737.737 0 0 1 .536-.22h2.611a.358.358 0 0 0 .132-.05l.945-.963a.296.296 0 0 0 .053-.134v-.732a.422.422 0 0 0-.038-.135l-.962-.945a.281.281 0 0 0-.133-.065h-2.233a.273.273 0 0 0-.133.065l-1.225 1.223a.72.72 0 0 1-.524.224.721.721 0 0 1-.531-.222.717.717 0 0 1-.221-.522c0-.208.072-.388.216-.54l1.236-1.236c.328-.32.72-.48 1.176-.48h2.244c.456 0 .848.16 1.176.48l.974.972c.318.328.478.72.478 1.176v.744ZM412.286 28.22a.317.317 0 0 0 .053-.132v-5.22c0-.047-.023-.091-.068-.132l-.946-.962a.31.31 0 0 0-.131-.065h-3.355v7.524h3.367a.278.278 0 0 0 .132-.065l.948-.948Zm1.061-6.547c.327.328.491.72.491 1.176v5.244c0 .456-.16.848-.48 1.176l-.972.972c-.328.32-.72.48-1.176.48h-4.116a.728.728 0 0 1-.534-.222.728.728 0 0 1-.222-.534v-8.988c0-.208.074-.386.222-.534a.728.728 0 0 1 .534-.222h4.116c.456 0 .848.164 1.176.492l.961.96ZM417.117 27.721h1.5c.207 0 .385.074.533.222a.725.725 0 0 1 .223.534v1.5c0 .2-.074.374-.223.522a.727.727 0 0 1-.533.222h-1.5a.709.709 0 0 1-.521-.222.708.708 0 0 1-.223-.522v-1.5c0-.208.073-.386.223-.534a.709.709 0 0 1 .521-.222ZM428.544 29.174h.013c.208 0 .384.07.528.214a.703.703 0 0 1 .217.523.715.715 0 0 1-.216.525.761.761 0 0 1-.517.225l-4.187.061h-.025c-.456 0-.843-.161-1.164-.482l-.971-.971a1.621 1.621 0 0 1-.481-1.175v-2.245c0-.455.16-.847.481-1.175l.971-.972c.329-.32.72-.481 1.176-.481h2.244c.456 0 .848.161 1.176.481l1.236 1.235a.741.741 0 0 1 .216.529.73.73 0 0 1-.22.533.708.708 0 0 1-.519.223.732.732 0 0 1-.537-.225l-1.224-1.223a.27.27 0 0 0-.133-.064h-2.225a.262.262 0 0 0-.132.072l-.963.946a.4.4 0 0 0-.047.132v2.23a.49.49 0 0 0 .038.133l.963.945a.232.232 0 0 0 .12.053l4.182-.047ZM436.862 28.082V25.86a.367.367 0 0 0-.047-.131l-.96-.961a.313.313 0 0 0-.132-.058h-2.23a.35.35 0 0 0-.133.049l-.945.964a.293.293 0 0 0-.053.131v2.226a.28.28 0 0 0 .062.133l.945.962c.04.029.084.048.132.057h2.222a.324.324 0 0 0 .132-.057l.96-.96a.37.37 0 0 0 .047-.133Zm.048-4.38.973.972c.319.328.479.72.479 1.176v2.244c0 .456-.16.847-.479 1.176l-.973.97c-.328.322-.72.482-1.176.482h-2.244c-.456 0-.848-.16-1.176-.482l-.972-.97c-.32-.329-.48-.72-.48-1.176V25.85c0-.456.16-.848.48-1.176l.972-.972c.328-.32.72-.48 1.176-.48h2.244c.456 0 .848.16 1.176.48ZM446.134 23.702l.973.972c.319.328.479.719.479 1.175v4.128a.717.717 0 0 1-.222.523.718.718 0 0 1-.522.222.728.728 0 0 1-.533-.222.714.714 0 0 1-.223-.523V25.86a.372.372 0 0 0-.047-.132l-.96-.96a.34.34 0 0 0-.132-.058h-.361v5.266a.717.717 0 0 1-.222.523.715.715 0 0 1-.522.223.725.725 0 0 1-.533-.223.714.714 0 0 1-.223-.523V24.71h-1.5v5.266a.717.717 0 0 1-.222.523.715.715 0 0 1-.522.223.728.728 0 0 1-.533-.222.714.714 0 0 1-.223-.523v-6c0-.208.074-.385.223-.534a.727.727 0 0 1 .533-.221h4.116c.456 0 .848.16 1.176.48Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
      />
      <path
        style={{
          fill: '#434242'
        }}
        d="M0 .001h666.937v10.312H0z"
        transform="matrix(0 -.8302 1.92413 0 688.713 615.293)"
      />
      <path
        style={{
          fill: '#434242'
        }}
        d="M27.701 620.077h666.937v10.312H27.701z"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(27.95 628.447) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(31.365 628.447) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(694.451 608.455) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(697.867 608.455) scale(7.99992)"
      />
      <path
        d="M.198-.501c0-.111.059-.148.122-.148.069 0 .11.045.11.112 0 .07-.042.12-.126.202l-.259.251V0h.528v-.11H.236v-.002L.405-.27c.116-.109.166-.168.166-.275 0-.108-.072-.207-.248-.207-.159 0-.26.094-.261.251h.136Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(693.639 580.093) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(698.679 580.093) scale(7.99992)"
      />
      <path
        d="M.324-.325c.08 0 .128.043.128.117 0 .07-.055.117-.129.117-.068 0-.124-.039-.134-.122H.051c.007.118.079.228.268.228.174 0 .268-.101.268-.216 0-.105-.062-.162-.143-.182v-.003a.174.174 0 0 0 .124-.167c0-.111-.088-.199-.247-.199-.181 0-.257.111-.259.226h.132c.004-.078.045-.122.124-.122.063 0 .114.041.114.109 0 .066-.05.112-.117.112H.267v.102h.057Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(693.611 551.731) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(698.707 551.731) scale(7.99992)"
      />
      <path
        d="m.168-.275.175-.261c.03-.044.044-.079.044-.079h.002v.34H.168ZM.61-.17v-.106H.518v-.465H.362l-.325.474v.097h.349V0h.132v-.17H.61Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(693.551 523.369) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(698.767 523.369) scale(7.99992)"
      />
      <path
        d="M.444-.239c0 .099-.064.148-.134.148-.072 0-.12-.033-.127-.112H.051c.008.107.067.218.259.218.174 0 .271-.111.271-.257 0-.166-.102-.248-.23-.248a.195.195 0 0 0-.149.063H.2l.017-.205h.32v-.109H.111l-.035.413H.19c.026-.04.068-.058.123-.058.076 0 .131.053.131.147Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(693.615 495.007) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(698.703 495.007) scale(7.99992)"
      />
      <path
        d="M.583-.571C.572-.677.503-.752.353-.752c-.191 0-.296.143-.296.419 0 .262.123.348.278.348.173 0 .269-.116.269-.26 0-.161-.109-.238-.227-.238-.08 0-.147.037-.178.098H.195c.004-.168.054-.269.156-.269.06 0 .096.032.106.083h.126Zm-.245.482c-.066 0-.129-.044-.129-.146 0-.098.054-.145.129-.145.073 0 .128.051.128.145 0 .102-.065.146-.128.146Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(693.539 466.645) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(698.779 466.645) scale(7.99992)"
      />
      <path
        d="M.088 0h.14L.53-.662v-.079H.028v.111h.347L.088 0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(693.983 438.283) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(698.335 438.283) scale(7.99992)"
      />
      <path
        d="M.072-.549c0 .09.056.145.119.166v.003C.119-.361.049-.307.049-.2c0 .125.103.216.274.216.166 0 .275-.095.275-.216 0-.109-.068-.162-.143-.18v-.003a.168.168 0 0 0 .119-.166c0-.115-.092-.203-.251-.203s-.251.088-.251.203Zm.251-.106c.064 0 .119.037.119.116 0 .077-.056.116-.119.116-.064 0-.119-.039-.119-.116 0-.079.054-.116.119-.116Zm0 .575C.25-.08.185-.119.185-.203c0-.086.064-.125.138-.125.076 0 .139.039.139.125 0 .084-.063.123-.139.123Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(693.571 409.921) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(698.747 409.921) scale(7.99992)"
      />
      <path
        d="M.318-.645c.065 0 .132.046.132.139 0 .09-.058.139-.132.139-.07 0-.129-.048-.129-.139 0-.098.068-.139.129-.139Zm-.251.47c.016.121.103.19.238.19.18 0 .292-.123.292-.413 0-.244-.104-.354-.276-.354-.166 0-.27.112-.27.253 0 .157.119.234.233.234.08 0 .142-.035.171-.089h.003c-.002.18-.051.268-.151.268-.056 0-.103-.032-.114-.089H.067Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(693.523 381.559) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(698.795 381.559) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(691.667 353.197) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(695.083 353.197) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(700.65 353.197) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(692.743 324.835) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(696.159 324.835) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(699.575 324.835) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(691.931 296.473) scale(7.99992)"
      />
      <path
        d="M.198-.501c0-.111.059-.148.122-.148.069 0 .11.045.11.112 0 .07-.042.12-.126.202l-.259.251V0h.528v-.11H.236v-.002L.405-.27c.116-.109.166-.168.166-.275 0-.108-.072-.207-.248-.207-.159 0-.26.094-.261.251h.136Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(695.347 296.473) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(700.387 296.473) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(691.943 268.111) scale(7.99992)"
      />
      <path
        d="M.324-.325c.08 0 .128.043.128.117 0 .07-.055.117-.129.117-.068 0-.124-.039-.134-.122H.051c.007.118.079.228.268.228.174 0 .268-.101.268-.216 0-.105-.062-.162-.143-.182v-.003a.174.174 0 0 0 .124-.167c0-.111-.088-.199-.247-.199-.181 0-.257.111-.259.226h.132c.004-.078.045-.122.124-.122.063 0 .114.041.114.109 0 .066-.05.112-.117.112H.267v.102h.057Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(695.279 268.111) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(700.375 268.111) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(691.863 239.749) scale(7.99992)"
      />
      <path
        d="m.168-.275.175-.261c.03-.044.044-.079.044-.079h.002v.34H.168ZM.61-.17v-.106H.518v-.465H.362l-.325.474v.097h.349V0h.132v-.17H.61Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(695.239 239.749) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(700.455 239.749) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(691.907 211.387) scale(7.99992)"
      />
      <path
        d="M.444-.239c0 .099-.064.148-.134.148-.072 0-.12-.033-.127-.112H.051c.008.107.067.218.259.218.174 0 .271-.111.271-.257 0-.166-.102-.248-.23-.248a.195.195 0 0 0-.149.063H.2l.017-.205h.32v-.109H.111l-.035.413H.19c.026-.04.068-.058.123-.058.076 0 .131.053.131.147Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(695.323 211.387) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(700.41 211.387) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(691.831 183.025) scale(7.99992)"
      />
      <path
        d="M.583-.571C.572-.677.503-.752.353-.752c-.191 0-.296.143-.296.419 0 .262.123.348.278.348.173 0 .269-.116.269-.26 0-.161-.109-.238-.227-.238-.08 0-.147.037-.178.098H.195c.004-.168.054-.269.156-.269.06 0 .096.032.106.083h.126Zm-.245.482c-.066 0-.129-.044-.129-.146 0-.098.054-.145.129-.145.073 0 .128.051.128.145 0 .102-.065.146-.128.146Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(695.247 183.025) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(700.487 183.025) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(692.235 154.663) scale(7.99992)"
      />
      <path
        d="M.088 0h.14L.53-.662v-.079H.028v.111h.347L.088 0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(695.731 154.663) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(700.083 154.663) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(691.883 126.301) scale(7.99992)"
      />
      <path
        d="M.072-.549c0 .09.056.145.119.166v.003C.119-.361.049-.307.049-.2c0 .125.103.216.274.216.166 0 .275-.095.275-.216 0-.109-.068-.162-.143-.18v-.003a.168.168 0 0 0 .119-.166c0-.115-.092-.203-.251-.203s-.251.088-.251.203Zm.251-.106c.064 0 .119.037.119.116 0 .077-.056.116-.119.116-.064 0-.119-.039-.119-.116 0-.079.054-.116.119-.116Zm0 .575C.25-.08.185-.119.185-.203c0-.086.064-.125.138-.125.076 0 .139.039.139.125 0 .084-.063.123-.139.123Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(695.259 126.301) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(700.435 126.301) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(691.835 97.939) scale(7.99992)"
      />
      <path
        d="M.318-.645c.065 0 .132.046.132.139 0 .09-.058.139-.132.139-.07 0-.129-.048-.129-.139 0-.098.068-.139.129-.139Zm-.251.47c.016.121.103.19.238.19.18 0 .292-.123.292-.413 0-.244-.104-.354-.276-.354-.166 0-.27.112-.27.253 0 .157.119.234.233.234.08 0 .142-.035.171-.089h.003c-.002.18-.051.268-.151.268-.056 0-.103-.032-.114-.089H.067Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(695.211 97.939) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(700.483 97.939) scale(7.99992)"
      />
      <path
        d="M.198-.501c0-.111.059-.148.122-.148.069 0 .11.045.11.112 0 .07-.042.12-.126.202l-.259.251V0h.528v-.11H.236v-.002L.405-.27c.116-.109.166-.168.166-.275 0-.108-.072-.207-.248-.207-.159 0-.26.094-.261.251h.136Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(690.615 70.008) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(695.655 70.008) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(701.223 70.008) scale(7.99992)"
      />
      <path
        d="M.198-.501c0-.111.059-.148.122-.148.069 0 .11.045.11.112 0 .07-.042.12-.126.202l-.259.251V0h.528v-.11H.236v-.002L.405-.27c.116-.109.166-.168.166-.275 0-.108-.072-.207-.248-.207-.159 0-.26.094-.261.251h.136Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(55.318 628.447) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(60.358 628.447) scale(7.99992)"
      />
      <path
        d="M.324-.325c.08 0 .128.043.128.117 0 .07-.055.117-.129.117-.068 0-.124-.039-.134-.122H.051c.007.118.079.228.268.228.174 0 .268-.101.268-.216 0-.105-.062-.162-.143-.182v-.003a.174.174 0 0 0 .124-.167c0-.111-.088-.199-.247-.199-.181 0-.257.111-.259.226h.132c.004-.078.045-.122.124-.122.063 0 .114.041.114.109 0 .066-.05.112-.117.112H.267v.102h.057Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(84.315 628.447) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(89.411 628.447) scale(7.99992)"
      />
      <path
        d="m.168-.275.175-.261c.03-.044.044-.079.044-.079h.002v.34H.168ZM.61-.17v-.106H.518v-.465H.362l-.325.474v.097h.349V0h.132v-.17H.61Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(112.455 628.447) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(117.671 628.447) scale(7.99992)"
      />
      <path
        d="M.444-.239c0 .099-.064.148-.134.148-.072 0-.12-.033-.127-.112H.051c.008.107.067.218.259.218.174 0 .271-.111.271-.257 0-.166-.102-.248-.23-.248a.195.195 0 0 0-.149.063H.2l.017-.205h.32v-.109H.111l-.035.413H.19c.026-.04.068-.058.123-.058.076 0 .131.053.131.147Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(141.006 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(146.094 628.327) scale(7.99992)"
      />
      <path
        d="M.583-.571C.572-.677.503-.752.353-.752c-.191 0-.296.143-.296.419 0 .262.123.348.278.348.173 0 .269-.116.269-.26 0-.161-.109-.238-.227-.238-.08 0-.147.037-.178.098H.195c.004-.168.054-.269.156-.269.06 0 .096.032.106.083h.126Zm-.245.482c-.066 0-.129-.044-.129-.146 0-.098.054-.145.129-.145.073 0 .128.051.128.145 0 .102-.065.146-.128.146Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(169.15 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(174.39 628.327) scale(7.99992)"
      />
      <path
        d="M.088 0h.14L.53-.662v-.079H.028v.111h.347L.088 0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(197.956 628.328) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(202.308 628.328) scale(7.99992)"
      />
      <path
        d="M.072-.549c0 .09.056.145.119.166v.003C.119-.361.049-.307.049-.2c0 .125.103.216.274.216.166 0 .275-.095.275-.216 0-.109-.068-.162-.143-.18v-.003a.168.168 0 0 0 .119-.166c0-.115-.092-.203-.251-.203s-.251.088-.251.203Zm.251-.106c.064 0 .119.037.119.116 0 .077-.056.116-.119.116-.064 0-.119-.039-.119-.116 0-.079.054-.116.119-.116Zm0 .575C.25-.08.185-.119.185-.203c0-.086.064-.125.138-.125.076 0 .139.039.139.125 0 .084-.063.123-.139.123Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(225.906 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(231.082 628.327) scale(7.99992)"
      />
      <path
        d="M.318-.645c.065 0 .132.046.132.139 0 .09-.058.139-.132.139-.07 0-.129-.048-.129-.139 0-.098.068-.139.129-.139Zm-.251.47c.016.121.103.19.238.19.18 0 .292-.123.292-.413 0-.244-.104-.354-.276-.354-.166 0-.27.112-.27.253 0 .157.119.234.233.234.08 0 .142-.035.171-.089h.003c-.002.18-.051.268-.151.268-.056 0-.103-.032-.114-.089H.067Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(254.219 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(259.49 628.327) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(280.725 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(284.141 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(289.709 628.327) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(310.227 628.327) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(313.643 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(317.059 628.327) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(337.777 628.327) scale(7.99992)"
      />
      <path
        d="M.198-.501c0-.111.059-.148.122-.148.069 0 .11.045.11.112 0 .07-.042.12-.126.202l-.259.251V0h.528v-.11H.236v-.002L.405-.27c.116-.109.166-.168.166-.275 0-.108-.072-.207-.248-.207-.159 0-.26.094-.261.251h.136Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(341.193 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(346.233 628.327) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(366.151 628.327) scale(7.99992)"
      />
      <path
        d="M.324-.325c.08 0 .128.043.128.117 0 .07-.055.117-.129.117-.068 0-.124-.039-.134-.122H.051c.007.118.079.228.268.228.174 0 .268-.101.268-.216 0-.105-.062-.162-.143-.182v-.003a.174.174 0 0 0 .124-.167c0-.111-.088-.199-.247-.199-.181 0-.257.111-.259.226h.132c.004-.078.045-.122.124-.122.063 0 .114.041.114.109 0 .066-.05.112-.117.112H.267v.102h.057Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(369.487 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(374.583 628.327) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(394.433 628.327) scale(7.99992)"
      />
      <path
        d="m.168-.275.175-.261c.03-.044.044-.079.044-.079h.002v.34H.168ZM.61-.17v-.106H.518v-.465H.362l-.325.474v.097h.349V0h.132v-.17H.61Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(397.809 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(403.025 628.327) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(422.839 628.327) scale(7.99992)"
      />
      <path
        d="M.444-.239c0 .099-.064.148-.134.148-.072 0-.12-.033-.127-.112H.051c.008.107.067.218.259.218.174 0 .271-.111.271-.257 0-.166-.102-.248-.23-.248a.195.195 0 0 0-.149.063H.2l.017-.205h.32v-.109H.111l-.035.413H.19c.026-.04.068-.058.123-.058.076 0 .131.053.131.147Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(426.255 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(431.343 628.327) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(451.125 628.327) scale(7.99992)"
      />
      <path
        d="M.583-.571C.572-.677.503-.752.353-.752c-.191 0-.296.143-.296.419 0 .262.123.348.278.348.173 0 .269-.116.269-.26 0-.161-.109-.238-.227-.238-.08 0-.147.037-.178.098H.195c.004-.168.054-.269.156-.269.06 0 .096.032.106.083h.126Zm-.245.482c-.066 0-.129-.044-.129-.146 0-.098.054-.145.129-.145.073 0 .128.051.128.145 0 .102-.065.146-.128.146Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(454.541 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(459.78 628.327) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(479.891 628.327) scale(7.99992)"
      />
      <path
        d="M.088 0h.14L.53-.662v-.079H.028v.111h.347L.088 0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(483.387 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(487.739 628.327) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(507.901 628.327) scale(7.99992)"
      />
      <path
        d="M.072-.549c0 .09.056.145.119.166v.003C.119-.361.049-.307.049-.2c0 .125.103.216.274.216.166 0 .275-.095.275-.216 0-.109-.068-.162-.143-.18v-.003a.168.168 0 0 0 .119-.166c0-.115-.092-.203-.251-.203s-.251.088-.251.203Zm.251-.106c.064 0 .119.037.119.116 0 .077-.056.116-.119.116-.064 0-.119-.039-.119-.116 0-.079.054-.116.119-.116Zm0 .575C.25-.08.185-.119.185-.203c0-.086.064-.125.138-.125.076 0 .139.039.139.125 0 .084-.063.123-.139.123Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(511.277 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(516.453 628.327) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(536.215 628.327) scale(7.99992)"
      />
      <path
        d="M.318-.645c.065 0 .132.046.132.139 0 .09-.058.139-.132.139-.07 0-.129-.048-.129-.139 0-.098.068-.139.129-.139Zm-.251.47c.016.121.103.19.238.19.18 0 .292-.123.292-.413 0-.244-.104-.354-.276-.354-.166 0-.27.112-.27.253 0 .157.119.234.233.234.08 0 .142-.035.171-.089h.003c-.002.18-.051.268-.151.268-.056 0-.103-.032-.114-.089H.067Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(539.591 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(544.863 628.327) scale(7.99992)"
      />
      <path
        d="M.198-.501c0-.111.059-.148.122-.148.069 0 .11.045.11.112 0 .07-.042.12-.126.202l-.259.251V0h.528v-.11H.236v-.002L.405-.27c.116-.109.166-.168.166-.275 0-.108-.072-.207-.248-.207-.159 0-.26.094-.261.251h.136Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(563.597 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(568.637 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(574.205 628.327) scale(7.99992)"
      />
      <path
        d="M.198-.501c0-.111.059-.148.122-.148.069 0 .11.045.11.112 0 .07-.042.12-.126.202l-.259.251V0h.528v-.11H.236v-.002L.405-.27c.116-.109.166-.168.166-.275 0-.108-.072-.207-.248-.207-.159 0-.26.094-.261.251h.136Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(592.995 628.327) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(598.115 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(601.53 628.327) scale(7.99992)"
      />
      <path
        d="M.198-.501c0-.111.059-.148.122-.148.069 0 .11.045.11.112 0 .07-.042.12-.126.202l-.259.251V0h.528v-.11H.236v-.002L.405-.27c.116-.109.166-.168.166-.275 0-.108-.072-.207-.248-.207-.159 0-.26.094-.261.251h.136Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(620.564 628.327) scale(7.99992)"
      />
      <path
        d="M.198-.501c0-.111.059-.148.122-.148.069 0 .11.045.11.112 0 .07-.042.12-.126.202l-.259.251V0h.528v-.11H.236v-.002L.405-.27c.116-.109.166-.168.166-.275 0-.108-.072-.207-.248-.207-.159 0-.26.094-.261.251h.136Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(625.644 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(630.684 628.327) scale(7.99992)"
      />
      <path
        d="M.198-.501c0-.111.059-.148.122-.148.069 0 .11.045.11.112 0 .07-.042.12-.126.202l-.259.251V0h.528v-.11H.236v-.002L.405-.27c.116-.109.166-.168.166-.275 0-.108-.072-.207-.248-.207-.159 0-.26.094-.261.251h.136Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(648.919 628.327) scale(7.99992)"
      />
      <path
        d="M.324-.325c.08 0 .128.043.128.117 0 .07-.055.117-.129.117-.068 0-.124-.039-.134-.122H.051c.007.118.079.228.268.228.174 0 .268-.101.268-.216 0-.105-.062-.162-.143-.182v-.003a.174.174 0 0 0 .124-.167c0-.111-.088-.199-.247-.199-.181 0-.257.111-.259.226h.132c.004-.078.045-.122.124-.122.063 0 .114.041.114.109 0 .066-.05.112-.117.112H.267v.102h.057Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(653.959 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(659.055 628.327) scale(7.99992)"
      />
      <path
        d="M.198-.501c0-.111.059-.148.122-.148.069 0 .11.045.11.112 0 .07-.042.12-.126.202l-.259.251V0h.528v-.11H.236v-.002L.405-.27c.116-.109.166-.168.166-.275 0-.108-.072-.207-.248-.207-.159 0-.26.094-.261.251h.136Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(677.26 628.327) scale(7.99992)"
      />
      <path
        d="m.168-.275.175-.261c.03-.044.044-.079.044-.079h.002v.34H.168ZM.61-.17v-.106H.518v-.465H.362l-.325.474v.097h.349V0h.132v-.17H.61Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(682.22 628.327) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(687.436 628.327) scale(7.99992)"
      />
      <path
        style={{
          fill: '#434242'
        }}
        d="M0 .001h666.937v10.312H0z"
        transform="matrix(0 -.8302 1.92413 0 8.576 615.293)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(14.313 608.455) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(17.73 608.455) scale(7.99992)"
      />
      <path
        d="M.198-.501c0-.111.059-.148.122-.148.069 0 .11.045.11.112 0 .07-.042.12-.126.202l-.259.251V0h.528v-.11H.236v-.002L.405-.27c.116-.109.166-.168.166-.275 0-.108-.072-.207-.248-.207-.159 0-.26.094-.261.251h.136Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(13.501 580.093) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(18.541 580.093) scale(7.99992)"
      />
      <path
        d="M.324-.325c.08 0 .128.043.128.117 0 .07-.055.117-.129.117-.068 0-.124-.039-.134-.122H.051c.007.118.079.228.268.228.174 0 .268-.101.268-.216 0-.105-.062-.162-.143-.182v-.003a.174.174 0 0 0 .124-.167c0-.111-.088-.199-.247-.199-.181 0-.257.111-.259.226h.132c.004-.078.045-.122.124-.122.063 0 .114.041.114.109 0 .066-.05.112-.117.112H.267v.102h.057Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(13.473 551.731) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(18.57 551.731) scale(7.99992)"
      />
      <path
        d="m.168-.275.175-.261c.03-.044.044-.079.044-.079h.002v.34H.168ZM.61-.17v-.106H.518v-.465H.362l-.325.474v.097h.349V0h.132v-.17H.61Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(13.413 523.369) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(18.63 523.369) scale(7.99992)"
      />
      <path
        d="M.444-.239c0 .099-.064.148-.134.148-.072 0-.12-.033-.127-.112H.051c.008.107.067.218.259.218.174 0 .271-.111.271-.257 0-.166-.102-.248-.23-.248a.195.195 0 0 0-.149.063H.2l.017-.205h.32v-.109H.111l-.035.413H.19c.026-.04.068-.058.123-.058.076 0 .131.053.131.147Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(13.477 495.007) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(18.565 495.007) scale(7.99992)"
      />
      <path
        d="M.583-.571C.572-.677.503-.752.353-.752c-.191 0-.296.143-.296.419 0 .262.123.348.278.348.173 0 .269-.116.269-.26 0-.161-.109-.238-.227-.238-.08 0-.147.037-.178.098H.195c.004-.168.054-.269.156-.269.06 0 .096.032.106.083h.126Zm-.245.482c-.066 0-.129-.044-.129-.146 0-.098.054-.145.129-.145.073 0 .128.051.128.145 0 .102-.065.146-.128.146Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(13.401 466.645) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(18.641 466.645) scale(7.99992)"
      />
      <path
        d="M.088 0h.14L.53-.662v-.079H.028v.111h.347L.088 0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(13.845 438.283) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(18.197 438.283) scale(7.99992)"
      />
      <path
        d="M.072-.549c0 .09.056.145.119.166v.003C.119-.361.049-.307.049-.2c0 .125.103.216.274.216.166 0 .275-.095.275-.216 0-.109-.068-.162-.143-.18v-.003a.168.168 0 0 0 .119-.166c0-.115-.092-.203-.251-.203s-.251.088-.251.203Zm.251-.106c.064 0 .119.037.119.116 0 .077-.056.116-.119.116-.064 0-.119-.039-.119-.116 0-.079.054-.116.119-.116Zm0 .575C.25-.08.185-.119.185-.203c0-.086.064-.125.138-.125.076 0 .139.039.139.125 0 .084-.063.123-.139.123Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(13.433 409.921) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(18.61 409.921) scale(7.99992)"
      />
      <path
        d="M.318-.645c.065 0 .132.046.132.139 0 .09-.058.139-.132.139-.07 0-.129-.048-.129-.139 0-.098.068-.139.129-.139Zm-.251.47c.016.121.103.19.238.19.18 0 .292-.123.292-.413 0-.244-.104-.354-.276-.354-.166 0-.27.112-.27.253 0 .157.119.234.233.234.08 0 .142-.035.171-.089h.003c-.002.18-.051.268-.151.268-.056 0-.103-.032-.114-.089H.067Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(13.385 381.559) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(18.657 381.559) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(11.53 353.197) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(14.945 353.197) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(20.513 353.197) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(12.605 324.835) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(16.021 324.835) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(19.437 324.835) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(11.793 296.473) scale(7.99992)"
      />
      <path
        d="M.198-.501c0-.111.059-.148.122-.148.069 0 .11.045.11.112 0 .07-.042.12-.126.202l-.259.251V0h.528v-.11H.236v-.002L.405-.27c.116-.109.166-.168.166-.275 0-.108-.072-.207-.248-.207-.159 0-.26.094-.261.251h.136Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(15.21 296.473) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(20.25 296.473) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(11.805 268.111) scale(7.99992)"
      />
      <path
        d="M.324-.325c.08 0 .128.043.128.117 0 .07-.055.117-.129.117-.068 0-.124-.039-.134-.122H.051c.007.118.079.228.268.228.174 0 .268-.101.268-.216 0-.105-.062-.162-.143-.182v-.003a.174.174 0 0 0 .124-.167c0-.111-.088-.199-.247-.199-.181 0-.257.111-.259.226h.132c.004-.078.045-.122.124-.122.063 0 .114.041.114.109 0 .066-.05.112-.117.112H.267v.102h.057Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(15.141 268.111) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(20.237 268.111) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(11.725 239.749) scale(7.99992)"
      />
      <path
        d="m.168-.275.175-.261c.03-.044.044-.079.044-.079h.002v.34H.168ZM.61-.17v-.106H.518v-.465H.362l-.325.474v.097h.349V0h.132v-.17H.61Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(15.101 239.749) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(20.317 239.749) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(11.77 211.387) scale(7.99992)"
      />
      <path
        d="M.444-.239c0 .099-.064.148-.134.148-.072 0-.12-.033-.127-.112H.051c.008.107.067.218.259.218.174 0 .271-.111.271-.257 0-.166-.102-.248-.23-.248a.195.195 0 0 0-.149.063H.2l.017-.205h.32v-.109H.111l-.035.413H.19c.026-.04.068-.058.123-.058.076 0 .131.053.131.147Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(15.185 211.387) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(20.273 211.387) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(11.693 183.025) scale(7.99992)"
      />
      <path
        d="M.583-.571C.572-.677.503-.752.353-.752c-.191 0-.296.143-.296.419 0 .262.123.348.278.348.173 0 .269-.116.269-.26 0-.161-.109-.238-.227-.238-.08 0-.147.037-.178.098H.195c.004-.168.054-.269.156-.269.06 0 .096.032.106.083h.126Zm-.245.482c-.066 0-.129-.044-.129-.146 0-.098.054-.145.129-.145.073 0 .128.051.128.145 0 .102-.065.146-.128.146Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(15.11 183.025) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(20.35 183.025) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(12.097 154.663) scale(7.99992)"
      />
      <path
        d="M.088 0h.14L.53-.662v-.079H.028v.111h.347L.088 0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(15.593 154.663) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(19.945 154.663) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(11.745 126.301) scale(7.99992)"
      />
      <path
        d="M.072-.549c0 .09.056.145.119.166v.003C.119-.361.049-.307.049-.2c0 .125.103.216.274.216.166 0 .275-.095.275-.216 0-.109-.068-.162-.143-.18v-.003a.168.168 0 0 0 .119-.166c0-.115-.092-.203-.251-.203s-.251.088-.251.203Zm.251-.106c.064 0 .119.037.119.116 0 .077-.056.116-.119.116-.064 0-.119-.039-.119-.116 0-.079.054-.116.119-.116Zm0 .575C.25-.08.185-.119.185-.203c0-.086.064-.125.138-.125.076 0 .139.039.139.125 0 .084-.063.123-.139.123Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(15.121 126.301) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(20.297 126.301) scale(7.99992)"
      />
      <path
        d="M.183 0h.135v-.743H.2c0 .047-.012.079-.035.1a.16.16 0 0 1-.108.033h-.02v.088h.146V0Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(11.697 97.939) scale(7.99992)"
      />
      <path
        d="M.318-.645c.065 0 .132.046.132.139 0 .09-.058.139-.132.139-.07 0-.129-.048-.129-.139 0-.098.068-.139.129-.139Zm-.251.47c.016.121.103.19.238.19.18 0 .292-.123.292-.413 0-.244-.104-.354-.276-.354-.166 0-.27.112-.27.253 0 .157.119.234.233.234.08 0 .142-.035.171-.089h.003c-.002.18-.051.268-.151.268-.056 0-.103-.032-.114-.089H.067Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(15.073 97.939) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(20.345 97.939) scale(7.99992)"
      />
      <path
        d="M.198-.501c0-.111.059-.148.122-.148.069 0 .11.045.11.112 0 .07-.042.12-.126.202l-.259.251V0h.528v-.11H.236v-.002L.405-.27c.116-.109.166-.168.166-.275 0-.108-.072-.207-.248-.207-.159 0-.26.094-.261.251h.136Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(10.477 70.008) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(15.517 70.008) scale(7.99992)"
      />
      <path
        d="M.057-.368c0 .259.105.383.287.383.179 0 .29-.125.29-.383 0-.26-.109-.383-.29-.383-.173 0-.287.125-.287.383Zm.287.279c-.088 0-.141-.078-.141-.278s.056-.281.141-.281c.085 0 .142.084.142.281 0 .193-.056.278-.142.278Z"
        style={{
          fill: '#fefefe',
          fillRule: 'nonzero'
        }}
        transform="translate(21.085 70.008) scale(7.99992)"
      />
    </svg>
  )
})
